import { render, staticRenderFns } from "./ku-article-layout.vue?vue&type=template&id=298db5e4"
import script from "./ku-article-layout.vue?vue&type=script&lang=js"
export * from "./ku-article-layout.vue?vue&type=script&lang=js"
import style0 from "./ku-article-layout.vue?vue&type=style&index=0&id=298db5e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports